import axios from 'axios';
import { req ,getByobj,exportExcel } from './axiosFun';
/**
 * 商品管理
 **/
// 商品管理-生成商品条形码
export const createBarcode = (params) => { return req("post", "/product/createBarcode", params) };



// WEBPACK FOOTER //
// ./src/api/productApi.js